import { Slot } from '@radix-ui/react-slot';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { ClassNames } from '@/shared/classNames';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

type ButtonProperties = ButtonHTMLAttributes<HTMLButtonElement> & {
  asChild?: boolean;
  children: ReactNode;
  variant?: ButtonVariant;
};

const variantClasses: Record<ButtonVariant, string> = {
  danger: 'border-critical bg-critical text-raised hover:bg-critical/90',
  ghost: 'border-transparent bg-transparent text-muted hover:bg-selection hover:text-ink',
  primary: 'border-action bg-action text-raised hover:bg-action-hover',
  secondary: 'border-line bg-raised text-ink hover:border-line-strong hover:bg-selection',
};

export const Button = ({
  asChild = false,
  children,
  className,
  type = 'button',
  variant = 'secondary',
  ...properties
}: ButtonProperties) => {
  const Component = asChild ? Slot : 'button';

  return (
    <Component
      className={ClassNames(
        'inline-flex min-h-10 items-center justify-center gap-2 rounded-md border px-3.5 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        variantClasses[variant],
        className,
      )}
      type={type}
      {...properties}
    >
      {children}
    </Component>
  );
};
